/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";

function CardsImage (props) {
    
    const image = props?.image;
    const width = props?.width ?? 200;

    const { alt, title, url } = image || {};

    return (
        <Fragment>
            {image && (
                <div className='cards-image-container'>
                    <img
                        alt={alt}
                        title={title}
                        width={width}
                        src={url}
                    />
                </div>
            )}
        </Fragment>
    );
}

export { CardsImage };
